<template>
  <div class="w-100">
    <v-chart
      chart-type="doughnut"
      :data-sets="dataSets"
      :labels="Object.keys(this.ageCounts)"
      size="sm"
      :download-enabled="false"
      :show-legend="false"
    />
  </div>
</template>

<script>
import { COLORS_LIGHT } from '@/common/utils/constants';
import Chart from '@/organisation/components/dashboard/Chart.vue';

const COLORS = {
  '30-': COLORS_LIGHT.red,
  '30-44': COLORS_LIGHT.blue,
  '45-59': COLORS_LIGHT.green,
  '60+': COLORS_LIGHT.grey,
};

export default {
  name: 'AgeDoughnutChart',
  components: {
    'v-chart': Chart,
  },
  props: {
    ages: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      ageCounts: null,
    };
  },
  computed: {
    dataSets() {
      return [{
        data: Object.values(this.ageCounts),
        backgroundColor: Object.keys(this.ageCounts).map((age) => (COLORS[age])),
        hoverOffset: 4,
      }];
    },
  },
  methods: {
    groupAges() {
      const ageCounts = {
        '30-': 0,
        '30-44': 0,
        '45-59': 0,
        '60+': 0,
      };
      this.ages.forEach((age) => {
        if (age < 30) {
          ageCounts['30-'] += 1;
        } else if (age < 45) {
          ageCounts['30-44'] += 1;
        } else if (age < 60) {
          ageCounts['45-59'] += 1;
        } else {
          ageCounts['60+'] += 1;
        }
      });
      this.ageCounts = ageCounts;
    },
  },
  created() {
    this.groupAges();
  },
};
</script>
